export const colors = {
  dark: "#23120b",
  main: "#23049d",
  light: "#f1f1f1",
  gray: "#CACACA",
};
